const content = {
  component: "PageTypeA",
  cssClass: "page-three",
  meta: {
    title: "التكنولوجيا السحابية تعزز الثقة والشفافية في عمليات الشحن ",
    description: `أحدثت تكنولوجيا "البلوك تشين" تطورًا جوهريًا في الشحن البحري، أدى إلى تعزيز الكفاءة والشفافية بالنسبة لكل الأطراف المعنية، من ميناء الشحن إلى ميناء الوصول.`,
    og: {
      type: "website",
      title: `تساعد تكنولوجيا "البلوك تشين" على تبسيط تعاملات الشحن - اعرف المزيد`,
      description: `الشحن عملية معقّدة للغاية تتطلب التعاون المتبادل بين شركات الشحن، ووكلاء الشحن، وشركات النقل، وسائقي الشاحنات، وهيئات الجمارك عبر مناطق زمنية مختلفة. وتعمل تكنولوجيا "البلوك تشين" على تبسيط تبادُل وثائق البضائع المشحونة من خلال إتاحة منصة رقمية واحدة موثوق فيها يمكنها التنسيق بين كل الأطراف وتحسين العملية برمتها.`,
      image: require("../../assets/images/social/trust-and-transparecy-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: `اعرف كيف تعزز تكنولوجيا "البلوك تشين" من كفاءة شركات الشحن`,
      description: `شركة CargoSmart تبسّط تعاملات الشحن. باستخدام تكنولوجيا "البلوك تشين" يمكن إدارة منظومة التوريد من منصة واحدة مما يساهم في توفير الشفافية والحماية والكفاءة في قطاع معروف بالتعقيد الشديد.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/trust-and-transparecy-300x300.jpg")
    }
  },
  title:
    "<span>التكنولوجيا السحابية تعزز الثقة والشفافية في عمليات الشحن</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/trust-and-transparency-pre.jpg"),
    loaded: require("../../assets/images/bgs/trust-and-transparency.jpg"),
    mobile: require("../../assets/images/bgs/trust-and-transparency-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `هل تعلم أن تجهيز شحنة من البضائع والسلع للإبحار من الميناء يتطلب مشاركة أكثر من 30 فردًا و200 وثيقة! لا عجب أن يستغرق تجهيز كل المعلومات المطلوبة للشحن وقتًا طويلًا وأن يتكرر حدوث الأخطاء. وبالطبع قد يؤدي ذلك إلى وجود السلع والسفن والشاحنات في المكان الخطأ، الأمر الذي يُسبب المزيد من التأخير وتكاليف إضافية.`,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        لتبسيط العمليات المعّقدة في منظومة التوريد، طورت CargoSmart Limited، وهي شركة عالمية متخصصة في تطوير حلول برامج ونُظم الشحن، نظامًا يعتمد على تكنولوجيا "البلوك تشين". وكان هدفها هو إتاحة المعلومات الموثوقة عن شحنات البضائع بسرعة وسهولة لمختلف الأطراف المعنية، والمشاركة في تسريع حركة السلع والبضائع.   
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/ship.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>فالشحن البحري لهذه السلع والبضائع في الغالب هو أوفر وسائل النقل عبر المسافات الطويلة. وبدون الشحن، سيُصبح من المستحيل استيراد/تصدير سلع وأغذية بأسعار في متناول الجميع. يُمكن القول بكل ثقة إن قطاع الشحن البحري، أكثر من أي مجال أو قطاع آخر، هو المحرّك الرئيسي الذي يجعل الاقتصاد العالمي ممكنًا. </p>
          <p>ما الذي يجعل منظومة الشحن بهذا التعقيد؟ تتكوّن منظومة الشحن من عدة أطراف، بدءًا من شركات الشحن، ووكلاء الشحن وشركات النقل، وصولاً إلى سائقي الشاحنات وهيئات الجمارك في دول مختلفة وفي مناطق زمنية مختلفة، وبنُظم عمل شديدة الاختلاف. ويجب أن يتعاون هؤلاء جميعًا عبر عمليات معقدة في الغالب. ولأن الشحن هو أحد أقدم القطاعات في العالم، فهو يميل إلى البطء في تطبيق أحدث التكنولوجيات، وغالبًا ما يعتمد على المعاملات اليدوية والمستندات الورقية.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>تعمل شركة CargoSmart على إحداث تغيير جوهري في هذا الوضع القائم، وتعزيز سلاسة إجراءات ومعاملات الشحن باستخدام منصة تكنولوجيا "البلوك تشين" السحابية من Oracle. وقد ساهم ذلك في ابتكار نظام يُساعد على رصد تعاملات الشحن وتتبّعها، مما يُعزز مستويات الثقة والشفافية في النظام.</p>
          <p>تستخدم مبادرة CargoSmart تكنولوجيا "البلوك تشين" في توثيق بيانات البضائع المشحونة من أجل تبسيط العمليات الحالية المعقدة في منظومة التوريد. وتهدف الشركة إلى تزويد المؤسسات والجهات المعنية بمنصة رقمية موحّدة ومعتَمَدة لإدارة وثائق الشحن، بما يُمكّنهم من التعاون بكفاءة أكبر والحصول على نسخة واحدة للحقيقة غير قابلة للتعديل.</p>
          <p>ويمكن الرجوع إلى هذا النظام حتى يتمكّن جميع المشاركين في عملية الشحن من تتبّع ورصد سير البضائع في مراحل النقل، واتخاذ الإجراءات والتدابير الفورية إذا حدث أمر غير متوقع يُعطّل عملية الشحن أو يعرقلها كظروف المناخ القاسية مثل إعصار "فلورنس" وإعصار "مانكوت".</p>
        `,
        type: "default",
        backgroundImage: require("../../assets/images/bgs/TrustAndTransparency_CargoSmart_bg.jpg")
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/blockchain.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        كذلك، سيؤدي تبسيط عملية توثيق الشحن إلى تعزيز الكفاءة من خلال تسريع فترات تسليم الوثائق والمستندات وتقليل النزاعات والخلافات. والنتيجة هي تسريع كل خطوات وعناصر تعاملات الشحن، مما يساعد على وصول السلع والبضائع إلى وجهتها في الوقت المحدد. 
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `البلوك تشين" من Oracle، والانتقال نحو تجديد الثقة والشفافية في منظومتنا للتوريد. وسيؤدي ذلك حتمًا إلى تطوير شامل في قطاع الشحن البحري.`,
        author: ` لايونيل لوي`,
        position: ` لمدير الشؤون التجارية في شركة`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          وفي المستقبل تتوقع الشركة انخفاضًا بنسبة 65% في مقدار الوقت المطلوب لجمع البيانات من مختلف الأطراف في عملية الشحن ودمجها وتأكيد التعامل مع بيانات الشحن ذات الطبيعة المتكررة في أغلب الوثائق، من خلال استغلال نظامها لإدارة وثائق الشحن الذي يعتمد على تكنولوجيا "البلوك تشين.
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `طوّر أعمالك مع حلول وتكنولوجيا Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: `تقرير "صُنّاع القرار والتكنولوجيا"`,
            url:
              "https://www.oracle.com/sa-ar/area-of-interest/it/leading-technologies-survey.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT",
            buttonCopy: "يعة لتقيّم أعمالك ذاتيًا"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "جرِّب حلول Oracle Cloud السحابية",
            url:
              "https://cloud.oracle.com/tryit?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_CT_TR_CM_SA_C38_Q34_CL&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_CT_TR_CM_SA_C38_Q34_CL",
            buttonCopy: "قم بجولة"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
